import React from 'react';
import CommonIcon from '../helpers/icons';
import { CreateAccountapi, verifyEmail,ResendOtp } from '../../action/createaccountapi';
import withRouter from "../custom/withRouter";
import { connect } from "react-redux";
import Spinner from 'react-bootstrap/Spinner';

class Alreadyjoined extends React.Component {
   constructor(){
      super()
   }
 

   
  render(){
    

    // console.log(this.state.otp);
    
    return(
        <div className='main'>
            <div>
                <div className='tpcontent'> 
                    <div className='pl-3'>         
                        <CommonIcon fileName={'Flazlogo'}/> 
                    </div>
                </div>
                
                <div className='submain1' style={{ width: '100vw', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <div className='form ' style={{ height: '400px', width: '600px',marginTop:'-100px' ,textAlign:'center'}}>
                           <h3 style={{fontSize:'30px'}}>Already joined this organization</h3>
                           <label style={{fontSize:'14px',marginTop:'20px'}}>You are already a part of the organization <span style={{fontWeight:'bold'}}>FLAZ</span>.</label>
                           <div className='ms-5' >
                                <button className='createbtn w-100' type=''  style={{ fontSize: '15px',marginTop:'50px' }} onClick={()=>{window.location.href='/login'}}>Go to App</button>
                            </div>
                        </div>
                        
                    </div>
            </div>
        </div>
    )
  }
}

export default Alreadyjoined;